import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button/Button";
import { ButtonColor, ButtonSize } from "@/components/Button/types";

import { Webhook } from "../../schema/webhook";
import { WebhookSignatureGuidance } from "./WebhookSignatureGuidance";
import { WebhookSigningCell } from "./WebhookSigningCell";
import { WebhookSigningActions } from "./useWebhookSigningDialogs";

/** The Edit dialog's Signing section (PREC-4249, frame 9): state, test event, rotate, guidance. */
export const WebhookSigningSection: FunctionComponent<{
	webhook: Webhook;
	actions: WebhookSigningActions;
}> = ({ webhook, actions }) => {
	const { t } = useTranslation();

	return (
		<div className="mb-4 flex flex-col gap-2" data-test="webhook-signing-section">
			<div className="text-ssm font-medium">{t("webhookSigning.section.title")}</div>
			<div className="flex flex-wrap items-start justify-between gap-2">
				<WebhookSigningCell webhook={webhook} />
				<div className="flex gap-2">
					<Button
						color={ButtonColor.ACTION_SECONDARY}
						size={ButtonSize.XS}
						testId="webhook-edit-test-event"
						title={t("webhookSigning.menu.sendTestEvent")}
						type="button"
						onClick={() => actions.sendTestEvent(webhook)}
					/>
					<Button
						color={ButtonColor.ACTION_SECONDARY}
						size={ButtonSize.XS}
						testId="webhook-edit-rotate"
						title={t("webhookSigning.menu.rotateSecret")}
						type="button"
						onClick={() => actions.rotateSecret(webhook)}
					/>
				</div>
			</div>
			<WebhookSignatureGuidance variant="short" />
		</div>
	);
};
